import React from 'react';
import { Form, FormGroup, FormControl, Button, Row, Col } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import utils from '../../utils';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

const ROWS_PER_PAGE_OPTIONS = [10, 20, 30];
const DEFAULT_ROWS_PER_PAGE = 30;

class HourlyReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            employeeID: '',
            executionNo: '',
            workOrder: '',
            masterJobNo: '',
            machines: [],
            reportRows: [],
            currentPage: 1,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            table: null,
            exportTable: null,
            loading: false,
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}.col-time{min-width:150px}.col-partno{min-width:200px}.col-remark{min-width:200px}</style>',
            tableHeader: '<table id="hourlyreport" border=1; cellspacing=0/>'
                + '<tr><th colspan="29">Production Overview</th></tr>'
                + '<tr><th colspan="6" class="left" style = "">Date: </th>'
                + '<th class="left" colspan="7" style = "">Operation Area: </th>'
                + '<th colspan="1" rowspan="4" class="left" style = ""><div class="vertical-text">Delta(Actual Cum - Plan Cum) AC-PC </div></th>'
                + '<th colspan="14" style = ""></th>'
                + '<th colspan="1" rowspan="4" class="col-remark" style = "">Remark: </th></tr>'
                + '<tr>'
                + '<th colspan="13" rowspan="2" class="left" style = "">Product Description: </th>'
                + '<th colspan="2" style = "background-color: #c75d00">Quality Loss</th>'
                + '<th colspan="6" style = "background-color: #0059b3">Technical Loss</th>'
                + '<th colspan="6" style = "background-color: #838383">Organization Loss</th>'
                + '</tr>'
                + '<tr>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #ffb85c"><div class="vertical-text">Q1 Engineering Reject</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #ffb85c"><div class="vertical-text">Q2 Production Reject</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T1 Machine</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T2 Tooling</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T3 Machine Equipment</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T4 Engineering build </div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T5 Jig & fixture</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #6599cd"><div class="vertical-text">T6 Change-over</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O1 Manpower</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O2 Material Delay</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O3 Facility</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O4 Material Not Available</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O5 Unplan Briefing/Training</div></th>'
                + '<th colspan="1" rowspan="2" class="left" style = "background-color: #c1c1c1"><div class="vertical-text">O6 QC Buyoff</div></th>'
                + '</tr>'
                + '<tr>'
                + '<th class="col-time" style = "">Time</th>'
                + '<th style = ""><div class="vertical-text">Machine Cycle Time</div></th>'
                + '<th style = ""><div class="vertical-text">Planned No. of Operator</div></th>'
                + '<th style = ""><div class="vertical-text">Actual No. of Operator</div></th>'
                + '<th class="col-partno" style = "">Part No</th>'
                + '<th style = "">Machine</th>'
                + '<th style = "">Job No</th>'
                + '<th style = "">Master Job No</th>'
                + '<th style = ""><div class="vertical-text short">Employee ID</div></th>'
                + '<th style = ""><div class="vertical-text">Plan Output(PO)</div> </th>'
                + '<th style = ""><div class="vertical-text">Plan Cum(PC)</div>  </th>'
                + '<th style = ""><div class="vertical-text">Actual Output(AO)</div>  </th>'
                + '<th style = ""><div class="vertical-text">Actual Cum(AC)</div>  </th>'
                + '</tr>'
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => response.text().then(text => (text ? JSON.parse(text) : [])))
                .then((machine) => {
                    if (machine) {
                        this.setState({ machines: machine });
                    }
                    return machine;
                })
                .catch(() => this.setState({ machines: [] }));
        }
    }

    tdWrap(content) {
        return '<td>' + content + '</td>';
    }

    /** Running plan/actual cumulative totals across full result set (order preserved from API). */
    enrichRowsWithCumulative(body) {
        const rows = Array.isArray(body) ? body : [];
        let planCum = 0;
        let actCum = 0;
        return rows.map((machine) => {
            planCum += Number(machine.planOutput) || 0;
            actCum += Number(machine.actOutput) || 0;
            const delta = actCum - planCum;
            return { machine, planCum, actCum, delta };
        });
    }

    rowToHtml({ machine, planCum, actCum, delta }) {
        const spillover = machine.spillover === true || machine.spillover === 1;
        let html = spillover ? '<tr class="spillover-row" style="background-color:#fff3cd" title="Spillover — excluded from OEE">' : '<tr>';
        html += this.tdWrap((new Date(machine.Timestamp)).toLocaleString());
        html += this.tdWrap(machine.cycleTime);
        html += this.tdWrap(machine.jsManpower || 0);
        html += this.tdWrap(machine.noOperator || 0);
        html += this.tdWrap(machine.executionNo);
        html += `<td><a href="/#/dailyoeereport?machine=${encodeURIComponent(machine.machine)}" target="_blank" style="color:#1a73e8;text-decoration:underline;cursor:pointer;">${machine.machine}</a></td>`;
        html += this.tdWrap(machine.jobOrder);
        html += this.tdWrap(machine.masterJobNo || '');
        html += this.tdWrap(machine.employeeID);
        html += this.tdWrap(machine.planOutput);
        html += this.tdWrap(planCum);
        html += this.tdWrap(machine.actOutput);
        html += this.tdWrap(actCum);
        html += this.tdWrap(delta < 0 ? `<span style="color: red;">${delta}</span>` : delta);
        html += this.tdWrap(machine.engReject);
        html += this.tdWrap(machine.prdReject);
        html += this.tdWrap(machine.machineDown);
        html += this.tdWrap(machine.mouldBreakdown);
        html += this.tdWrap(machine.machineEquipment || 0);
        html += this.tdWrap(machine.engineeringBuild);
        html += this.tdWrap(machine.jigFixture);
        html += this.tdWrap(machine.machineSupportDoc);
        html += this.tdWrap(machine.manpower);
        html += this.tdWrap(machine.materialDelay);
        html += this.tdWrap(machine.facility);
        html += this.tdWrap(machine.materialNotAvailable);
        html += this.tdWrap(machine.unplanBriefing);
        html += this.tdWrap(machine.qcBuyoff || 0);
        html += this.tdWrap(machine.remark === null ? '' : machine.remark);
        html += '</tr>';
        return html;
    }

    rowsToTableHtml(enrichedRows) {
        const { tableStyle, tableHeader } = this.state;
        let html = '';
        (enrichedRows || []).forEach((row) => {
            html += this.rowToHtml(row);
        });
        const raw = tableStyle + this.fillInDetails(tableHeader) + html.split('undefined').join('');
        return this.sanitizeVoidTags(
            utils.sanitizeVoidTags(raw)
                .replaceAll('</img>', '')
                .replaceAll('</input>', '')
                .replaceAll('</br>', '<br/>')
                .replaceAll('</hr>', '<hr/>')
        );
    }

    fillInDetails(tableHeader) {
        let header = tableHeader;
        header = header.split('Operation Area: ').join('Operation Area: ' + (this.state.selectedMachine || ''));
        header = header.split('Date: ').join('Date: ' + this.state.selectedStart + ' - ' + this.state.selectedEnd);
        return header;
    }

    getTotalPages(rowsPerPage = this.state.rowsPerPage) {
        const total = this.state.reportRows.length;
        return Math.max(1, Math.ceil(total / rowsPerPage) || 1);
    }

    renderTablePage(page = this.state.currentPage, rowsPerPage = this.state.rowsPerPage) {
        const { reportRows } = this.state;
        const totalPages = this.getTotalPages(rowsPerPage);
        const safePage = Math.min(Math.max(1, page), totalPages);
        const start = (safePage - 1) * rowsPerPage;
        const pageRows = reportRows.slice(start, start + rowsPerPage);
        this.setState({
            table: this.rowsToTableHtml(pageRows),
            exportTable: this.rowsToTableHtml(reportRows),
            currentPage: safePage,
            rowsPerPage,
        });
    }

    buildHtmlTable() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                machine: this.state.selectedMachine,
                start: this.state.selectedStart,
                end: this.state.selectedEnd,
                executionNo: this.state.executionNo,
                employeeID: this.state.employeeID,
                workOrder: this.state.workOrder,
                masterJobNo: this.state.masterJobNo,
            }),
        };

        if (localStorage.getItem('user') == null) {
            return Promise.resolve();
        }

        this.setState({ loading: true });

        return fetch(
            `${config.apiUrl}/getMachineByDate?company=${JSON.parse(localStorage.getItem('user')).accountId}`,
            requestOptions
        )
            .then((response) => response.text().then((text) => (text ? JSON.parse(text) : [])))
            .then((body) => {
                const reportRows = this.enrichRowsWithCumulative(body);
                this.setState(
                    { reportRows, currentPage: 1, rowsPerPage: DEFAULT_ROWS_PER_PAGE, loading: false },
                    () => this.renderTablePage(1, DEFAULT_ROWS_PER_PAGE)
                );
                return reportRows;
            })
            .catch(() => {
                this.setState({ loading: false, reportRows: [], table: null, exportTable: null });
            });
    }

    handlePageChange = (page) => {
        this.renderTablePage(page, this.state.rowsPerPage);
    };

    handleRowsPerPageChange = (e) => {
        const rowsPerPage = Math.min(30, Math.max(10, parseInt(e.target.value, 10) || DEFAULT_ROWS_PER_PAGE));
        this.renderTablePage(1, rowsPerPage);
    };

    exportExcel() {
        const prevTable = this.state.table;
        const exportHtml = this.state.exportTable || this.rowsToTableHtml(this.state.reportRows);
        this.setState({ table: exportHtml }, () => {
            utils.tableToExcel(
                'datatable',
                'Report',
                `HourlyReport_${this.state.selectedStart || ''}-${this.state.selectedEnd || ''}.xls`
            );
            this.setState({ table: prevTable });
        });
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    sanitizeVoidTags(html) {
        if (!html) return '';

        html = html.replace(/<\/?(INPUT|IMG|BR|HR|META|LINK|AREA|BASE|COL|COMMAND|EMBED|KEYGEN|PARAM|SOURCE|TRACK|WBR)\b[^>]*>/gi, (match) => {
            if (match.startsWith('</')) {
                return '';
            }
            if (!match.endsWith('/>')) {
                return match.replace(/>$/, ' />');
            }
            return match;
        });

        return html;
    }

    render() {
        const {
            executionNo,
            employeeID,
            workOrder,
            masterJobNo,
            table,
            reportRows,
            currentPage,
            rowsPerPage,
            loading,
            machines,
        } = this.state;
        const totalRows = reportRows.length;
        const totalPages = this.getTotalPages(rowsPerPage);
        const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
        const endRow = Math.min(currentPage * rowsPerPage, totalRows);

        return (
            <>
                <div className="container">
                <div style={{ marginBottom: '20px', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Items:</Form.Label>{' '}
                            <FormControl
                                as="select"
                                placeholder="select"
                                value={this.state.selectedMachine || 'select'}
                                onChange={(e) => {
                                    if (e.target.value !== 'select') {
                                        this.setState({ selectedMachine: e.target.value });
                                    } else {
                                        this.setState({ selectedMachine: undefined });
                                    }
                                }}
                            >
                                <option value="select">select</option>
                                {(machines || []).map((machine) => (
                                    <option key={machine.id} value={machine.machine}>
                                        {machine.machine}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>{' '}
                        <CustomDatePicker
                            label="Start"
                            controlId="formInlineStart"
                            value={this.state.selectedStart}
                            onChange={(value) => this.setState({ selectedStart: value })}
                        />{' '}
                        <CustomDatePicker
                            label="End"
                            controlId="formInlineEnd"
                            value={this.state.selectedEnd}
                            onChange={(value) => this.setState({ selectedEnd: value })}
                        />{' '}
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Part No</Form.Label>{' '}
                            <input
                                className="form-control"
                                name="executionNo"
                                value={executionNo}
                                onChange={this.handleChange}
                            />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Job No</Form.Label>{' '}
                            <input
                                className="form-control"
                                name="workOrder"
                                value={workOrder}
                                onChange={this.handleChange}
                            />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Master Job No</Form.Label>{' '}
                            <input
                                className="form-control"
                                name="masterJobNo"
                                value={masterJobNo}
                                onChange={this.handleChange}
                            />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Employee ID</Form.Label>{' '}
                            <input
                                className="form-control"
                                name="employeeID"
                                value={employeeID}
                                onChange={this.handleChange}
                            />
                        </FormGroup>{' '}
                        <Button
                            variant="primary"
                            style={{ float: 'right', margin: 10 }}
                            disabled={loading}
                            onClick={() => this.buildHtmlTable()}
                        >
                            {loading ? 'Loading...' : 'Show'}
                        </Button>
                    </Form>
                    <DatacoLoadingIndicator loading={loading} label="Loading hourly report" />
                    {table ? (
                        <div style={{ width: '100%' }}>
                            <Button
                                variant="primary"
                                style={{ float: 'right', margin: 10 }}
                                onClick={() => this.exportExcel()}
                            >
                                Export
                            </Button>
                        </div>
                    ) : null}
                    <a id="dlink" style={{ display: 'none' }} />
                </div>

                {table && totalRows > 0 ? (
                    <Row className="align-items-center mb-2" style={{ fontSize: '14px' }}>
                        <Col xs="auto">
                            <Form.Group className="mb-0 d-flex align-items-center gap-2">
                                <Form.Label className="mb-0">Rows per page</Form.Label>
                                <FormControl
                                    as="select"
                                    value={rowsPerPage}
                                    onChange={this.handleRowsPerPageChange}
                                    style={{ width: 'auto' }}
                                >
                                    {ROWS_PER_PAGE_OPTIONS.map((n) => (
                                        <option key={n} value={n}>
                                            {n}
                                        </option>
                                    ))}
                                </FormControl>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            Showing {startRow}–{endRow} of {totalRows}
                        </Col>
                        <Col xs="auto" className="ms-auto d-flex gap-2">
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={currentPage <= 1}
                                onClick={() => this.handlePageChange(currentPage - 1)}
                            >
                                Previous
                            </Button>
                            <span className="align-self-center">
                                Page {currentPage} of {totalPages}
                            </span>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={currentPage >= totalPages}
                                onClick={() => this.handlePageChange(currentPage + 1)}
                            >
                                Next
                            </Button>
                        </Col>
                    </Row>
                ) : null}

                </div>
                <div
                    id="datatable"
                    style={{
                        boxSizing: 'border-box',
                        overflowX: 'auto',
                        overflowY: 'auto',
                        padding: '0 12px',
                        width: '100%',
                    }}
                    dangerouslySetInnerHTML={{ __html: this.sanitizeVoidTags(table || '') }}
                />
            </>
        );
    }
}

export { HourlyReport };
